import {
  getErrorAsString,
  IAuthenticatedUserInfo,
  ILogger,
  logWebPerfData,
  registerUnhandledRejectionLogger,
  registerWebIntegrationsLogger,
  registerWindowOnErrorLogger} from '@notes/webintegrations-common'
import { initializeIcons } from '@uifabric/icons'
import { LocalizationService } from './localization/LocalizationService'
import { getHostNameFromUrl } from './shared/lib/getHostNameFromUrl'
import { EventName } from './shared/logger/EventName'
import { Log } from './shared/logger/Log'

/*
  Sets up non visual parts of the Frame around the canvas. Today this includes
  localization and logging.
*/

export class AppIntegrationSetup {
  public static async init(bootEvent: EventName, desiredLocale: string, userInfo?: IAuthenticatedUserInfo): Promise<void> {
    // TODO(jogonzal): The referrer will always be login.microsoftonline if we had to auth
    // We need to persist this through the oauth state as a query param, however this is ok for
    // an initial implementation
    Log.logger.logReportData(bootEvent, false /* isCriticalEvent */, undefined /* payloadNonPII */, {
      referrer: document.referrer,
      referrerDomain: document.referrer ? getHostNameFromUrl(document.referrer) : '',
      authType: userInfo ? userInfo.authType : '',
    })

    // Initialize localization
    await this.initLocalization(desiredLocale)

    // Register UI fabric icons and pull the fonts from the default SharePoint cdn
    initializeIcons('https://res.cdn.office.net/files/fabric-cdn-prod_20241209.001/assets/icons/')
  }

  // tslint:disable-next-line:no-any
  public static initLogging(_windowObj: any, logger: ILogger | undefined): void  {
    // We've chosen not to send data to aria
    console.warn('Warning: SDK Aria logging will be disabled for this session.')

    if (logger) {
      Log.initialize(logger)
    }

    // Registering logger for webintegrations-common library
    registerWebIntegrationsLogger(Log.logger)

    Log.logger.info('Performing initial setup')

    // Registering windowOnError and promise rejection loggers
    registerWindowOnErrorLogger()
    registerUnhandledRejectionLogger()

    // Logging web perf data
    logWebPerfData()
  }

  private static async initLocalization(desiredLocale: string): Promise<void> {
    try {
      await LocalizationService.changeLocale(desiredLocale)
    } catch (error) {
      Log.logger.error('Error when changing locale ' + getErrorAsString(error))
      // if the locale doesn't match try again with the default locale
      await LocalizationService.changeLocale(LocalizationService.DEFAULT_LOCALE)
    }
  }
}
